var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item&&_vm.item.type==='box')?_c('BoxCube',{attrs:{"item":_vm.item}}):(_vm.item&&_vm.item.type==='text')?_c('TextBox',{attrs:{"item":_vm.item}}):(_vm.item&&_vm.item.type==='image')?_c('ImageBox',{attrs:{"item":_vm.item}}):(_vm.item&&_vm.item.type==='icon')?_c('IconBox',{attrs:{"item":_vm.item}}):(_vm.item&&_vm.item.type==='button')?_c('BtnBox',{attrs:{"item":_vm.item}}):(_vm.item&&_vm.item.type==='separator')?_c('hr',{style:([
  _vm.item.margin?{
    marginTop: _vm.item.margin === 'xs' ? '2px'
    : _vm.item.margin === 'sm' ? '4px'
    : _vm.item.margin === 'md' ? '8px'
    : _vm.item.margin === 'lg' ? '12px'
    : _vm.item.margin === 'lg' ? '12px'
    : _vm.item.margin === 'xl' ? '16px'
    : _vm.item.margin === 'xxl' ? '20px'
    : _vm.item.margin
  }:{},
  _vm.item.color?{borderColor: _vm.item.color}:{},
  {width: '100%'}
])}):(_vm.item&&_vm.item.type==='filler')?_c('div',{staticClass:"mdBxFiller"}):_c('div',[_vm._v(_vm._s(_vm.item.type))])
}
var staticRenderFns = []

export { render, staticRenderFns }